export interface IStateData {
  name: string;
  code: string;
  subdivision: string;
}

export const mexicoStatesData: IStateData[] = [
  {
    name: 'Distrito Federal',
    code: 'MX-DIF',
    subdivision: 'federal district'
  },
  {
    name: 'Aguascalientes',
    code: 'MX-AGU',
    subdivision: 'state'
  },
  {
    name: 'Baja California',
    code: 'MX-BCN',
    subdivision: 'state'
  },
  {
    name: 'Baja California Sur',
    code: 'MX-BCS',
    subdivision: 'state'
  },
  {
    name: 'Campeche',
    code: 'MX-CAM',
    subdivision: 'state'
  },
  {
    name: 'Chiapas',
    code: 'MX-CHP',
    subdivision: 'state'
  },
  {
    name: 'Chihuahua',
    code: 'MX-CHH',
    subdivision: 'state'
  },
  {
    name: 'Coahuila',
    code: 'MX-COA',
    subdivision: 'state'
  },
  {
    name: 'Colima',
    code: 'MX-COL',
    subdivision: 'state'
  },
  {
    name: 'Durango',
    code: 'MX-DUR',
    subdivision: 'state'
  },
  {
    name: 'Guanajuato',
    code: 'MX-GUA',
    subdivision: 'state'
  },
  {
    name: 'Guerrero',
    code: 'MX-GRO',
    subdivision: 'state'
  },
  {
    name: 'Hidalgo',
    code: 'MX-HID',
    subdivision: 'state'
  },
  {
    name: 'Jalisco',
    code: 'MX-JAL',
    subdivision: 'state'
  },
  {
    name: 'Michoacán',
    code: 'MX-MIC',
    subdivision: 'state'
  },
  {
    name: 'Morelos',
    code: 'MX-MOR',
    subdivision: 'state'
  },
  {
    name: 'México',
    code: 'MX-MEX',
    subdivision: 'state'
  },
  {
    name: 'Nayarit',
    code: 'MX-NAY',
    subdivision: 'state'
  },
  {
    name: 'Nuevo León',
    code: 'MX-NLE',
    subdivision: 'state'
  },
  {
    name: 'Oaxaca',
    code: 'MX-OAX',
    subdivision: 'state'
  },
  {
    name: 'Puebla',
    code: 'MX-PUE',
    subdivision: 'state'
  },
  {
    name: 'Querétaro',
    code: 'MX-QUE',
    subdivision: 'state'
  },
  {
    name: 'Quintana Roo',
    code: 'MX-ROO',
    subdivision: 'state'
  },
  {
    name: 'San Luis Potosí',
    code: 'MX-SLP',
    subdivision: 'state'
  },
  {
    name: 'Sinaloa',
    code: 'MX-SIN',
    subdivision: 'state'
  },
  {
    name: 'Sonora',
    code: 'MX-SON',
    subdivision: 'state'
  },
  {
    name: 'Tabasco',
    code: 'MX-TAB',
    subdivision: 'state'
  },
  {
    name: 'Tamaulipas',
    code: 'MX-TAM',
    subdivision: 'state'
  },
  {
    name: 'Tlaxcala',
    code: 'MX-TLA',
    subdivision: 'state'
  },
  {
    name: 'Veracruz',
    code: 'MX-VER',
    subdivision: 'state'
  },
  {
    name: 'Yucatán',
    code: 'MX-YUC',
    subdivision: 'state'
  },
  {
    name: 'Zacatecas',
    code: 'MX-ZAC',
    subdivision: 'state'
  }
];
